/** @jsx jsx */

import { FormattedMessage, useIntl } from 'react-intl';

import { Icon } from '@zapier/zinnia-icons';
import { Link, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { PARTNER_CONTACT_FORM_PATH } from 'app/developer-v3/constants';

const Styles = {
  needHelpTitle: css`
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-template-columns: 20px 1fr;
    grid-column-gap: 15px;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;
  `,
};

export const ContactUs = () => {
  const intl = useIntl();
  return (
    <div>
      <div css={Styles.needHelpTitle}>
        <Icon name="navHelpFill" size={20} />
        <Text>
          {intl.formatMessage({
            defaultMessage: 'Need help?',
            id: 'partner.support.contact.need_help',
          })}
        </Text>
      </div>
      <Text tag="p">
        <FormattedMessage
          defaultMessage="<link>Tell us about your problem</link> and we'll connect you with the right resource or team."
          id="partner.support.contact.body"
          values={{
            link: chunks => (
              <Link href={PARTNER_CONTACT_FORM_PATH}>{chunks}</Link>
            ),
          }}
        />
      </Text>
    </div>
  );
};
